<template>
    <div>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <div class="card   abtg__default-card abtg__default-card-border">

            <div class="card-body ">
                <ul>
                    <li v-for="v in versionData">
                        Versione <strong>{{v.version}}</strong>
                        <ul>
                            <li v-for="a in v.activities">

                                <i class="fas fa-clock" style="color:lightgrey"></i>{{a.created_at}}

                                <span class="badge badge-default abtg__badge--improve" v-if="a.intensity === 1">Improved</span>
                                <span class="badge badge-default abtg__badge--new"
                                      v-if="a.intensity === 2">NEW</span>
                                {{a.description}}<br>
                                <em></em>
                            </li>
                        </ul>
                    </li>
                </ul>


            </div>
        </div>
    </div>
</template>

<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';
    export default{
        components: {
            NBread
        },
        computed: {
            ...mapState('n_track', ['versionData', 'bread_active', 'bread_list']),
        },

        created() {
            this.SET_DATA({name: 'bread_active', data: {label: 'Cosa c\'è di nuovo?'}});
            this.versionList();
        },
        methods: {
            ...mapActions('n_track', ['versionList']),
            ...mapMutations('n_track', ['SET_DATA']),
        }
    }
</script>